module.exports = __webpack_public_path__ + "img/Russia.9046e5a0.png";